// # Support routes configuration
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';

// # Import support components
import SupportDashboard from '../../roles/employees/support/support_dashboard';

// # Import shared components
import Profile from '../../general/profile/profile';
import Settings from '../../general/gen_pages/settings';

// # Support routes component
const SupportRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute requiredRole="support">
          <SupportDashboard />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute requiredRole="support">
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute requiredRole="support">
          <Settings />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default SupportRoutes; 